<template>
  <v-card flat height="100%">
    <v-card-title>
      <v-layout>
        <v-flex xs12 ma-2>Profil</v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <v-alert text color="info" v-if="passwortSaved">Das Passwort wurde erfolgreich geändert.</v-alert>
      <v-form ref="passwortForm" v-model="valid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12 sm6 md4 pa-1>
            <v-text-field
              v-model="currentPassword"
              type="password"
              label="Aktuelles Passwort"
              :rules="rules.currentPassword"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 pa-1>
            <v-text-field
              v-model="nextPassword"
              type="password"
              label="Neues Passwort"
              :rules="rules.nextPassword"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4 pa-1>
            <v-text-field
              v-model="checkNextPassword"
              type="password"
              label="Neues Passwort Wiederholung"
              :rules="rules.checkNextPassword"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
      <v-btn
        block
        color="primary"
        @click="changePassword"
        :disabled="disablePasswordButton"
      >Passwort ändern</v-btn>
      <v-divider class="my-4 info" style="opacity: 0.22"></v-divider>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      currentPassword: null,
      nextPassword: null,
      checkNextPassword: null,
      rules: {
        currentPassword: [
          v => !!v || "Das aktuellle Passwort darf nicht leer sein"
        ],
        nextPassword: [v => !!v || "Das neue Passwort darf nicht leer sein"],
        checkNextPassword: [
          v =>
            v === this.nextPassword ||
            "Die Wiederholung stimmt nicht mit dem neuen Kennwort überein"
        ]
      }
    };
  },
  computed: {
    ...mapState({
      passwortSaved: state => state.passwortSaved
    }),
    disablePasswordButton: function() {
      return (
        this.currentPassword !== null &&
        this.nextPassword !== null &&
        this.checkNextPassword !== null &&
        this.nextPassword !== this.checkNextPassword
      );
    }
  },
  watch: {
    passwortSaved: function(nV) {
      if (nV) {
        this.currentPassword = null;
        this.nextPassword = null;
        this.checkNextPassword = null;
      }
    }
  },
  mounted: function() {
    this.$store.commit("startPasswortChange");
  },
  methods: {
    changePassword: function() {
      if (this.$refs.passwortForm.validate()) {
        this.$store.commit("startPasswortChange");
        this.$store.commit("startLoading");
        this.$socket.sendObj({
          eventID:
            "de.t2med.lizenzomat.eventapi.usecase.profile.ChangePasswordRequestEvent",
          oldPassword: this.currentPassword,
          newPassword: this.nextPassword
        });
      }
    }
  }
};
</script>
